/* Rico Starr — shared behavior (The Gaygency, 2026-10): header mega menu, search bar, full-screen phone
   menu, bag icon, and the "ADD" buttons that add a one-variant product straight to the bag.
   No dependencies. Loaded with defer from layout/theme.liquid. */
(function () {
  'use strict';
  var doc = document;
  var header = doc.querySelector('[data-rx-header]');

  function qs(sel, root) { return (root || doc).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }


  /* ---------- product cards: the party photo is added the first time a computer hovers the card ---------- */
  function rxLife(card) {
    var s = card.querySelector('.rx-card-life-src');
    if (!s || card.querySelector('img.rx-card-life')) return;
    var img = doc.createElement('img');
    img.className = 'rx-card-life';
    img.alt = '';
    img.decoding = 'async';
    img.sizes = s.getAttribute('data-sizes') || '';
    img.srcset = s.getAttribute('data-srcset') || '';
    img.src = s.getAttribute('data-src') || '';
    img.addEventListener('load', function () { img.classList.add('is-ready'); });
    card.appendChild(img);
  }
  doc.addEventListener('mouseover', function (e) { var c = e.target.closest && e.target.closest('.rx-card-img'); if (c) rxLife(c); });
  doc.addEventListener('focusin', function (e) { var c = e.target.closest && e.target.closest('.rx-card-img'); if (c) rxLife(c); });

  /* ---------- mega menu ---------- */
  var megaBtn = qs('[data-rx-mega-toggle]');
  var mega = qs('[data-rx-mega]');
  var megaTimer = null;
  function megaSet(open) {
    if (!mega || !megaBtn) return;
    clearTimeout(megaTimer);
    mega.hidden = !open;
    megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) searchSet(false);
  }
  if (mega && megaBtn) {
    megaBtn.addEventListener('click', function () { megaSet(mega.hidden); });
    var hoverable = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if (hoverable) {
      var li = megaBtn.parentNode;
      [li, mega].forEach(function (el) {
        el.addEventListener('mouseenter', function () { megaSet(true); });
        el.addEventListener('mouseleave', function () { megaTimer = setTimeout(function () { megaSet(false); }, 160); });
      });
    }
    doc.addEventListener('click', function (e) {
      if (mega.hidden) return;
      if (mega.contains(e.target) || megaBtn.contains(e.target)) return;
      megaSet(false);
    });
  }

  /* ---------- search bar ---------- */
  var searchBtn = qs('[data-rx-search-toggle]');
  var search = qs('#rx-search');
  function searchSet(open) {
    if (!search || !searchBtn) return;
    search.hidden = !open;
    searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { megaSet(false); var i = qs('input', search); if (i) i.focus(); }
  }
  if (search && searchBtn) {
    searchBtn.addEventListener('click', function () { searchSet(search.hidden); });
    doc.addEventListener('click', function (e) {
      if (search.hidden) return;
      if (search.contains(e.target) || searchBtn.contains(e.target)) return;
      searchSet(false);
    });
  }

  /* ---------- phone menu: full screen, page locked behind it ---------- */
  var menu = qs('[data-rx-menu]');
  // The header section is sticky (its own stacking layer). Moving the menu to <body> is what lets its
  // z-index of 99000 beat every floating widget on the page (reviews tab, chat, bag bar).
  if (menu && menu.parentNode !== doc.body) doc.body.appendChild(menu);
  var menuOpeners = qsa('[data-rx-menu-open]');
  var lastFocus = null;
  // Lock the page behind the menu without losing the shopper's place (2026-10-06 phone test: closing the menu
  // used to jump back to the top). The body is pinned at its current offset and put back on close.
  var lockY = 0;
  function lockPage(on) {
    var b = doc.body;
    if (on) {
      lockY = window.scrollY || 0;
      b.style.position = 'fixed'; b.style.top = (-lockY) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
      doc.documentElement.classList.add('rx-lock');
    } else {
      doc.documentElement.classList.remove('rx-lock');
      b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
      window.scrollTo(0, lockY);
    }
  }
  function menuSet(open) {
    if (!menu) return;
    if (open === !menu.hidden) return;
    menu.hidden = !open;
    lockPage(open);
    menuOpeners.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      lastFocus = doc.activeElement;
      megaSet(false); searchSet(false);
      var c = qs('[data-rx-menu-close]', menu); if (c) c.focus();
    } else if (lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); }
  }
  if (menu) {
    menuOpeners.forEach(function (b) { b.addEventListener('click', function () { menuSet(true); }); });
    qsa('[data-rx-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { menuSet(false); }); });
    qsa('[data-rx-acc]', menu).forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = doc.getElementById(b.getAttribute('aria-controls'));
        var open = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      });
    });
    // Keep keyboard focus inside the open menu.
    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = qsa('a[href],button:not([disabled]),input', menu).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // Leaving phone width with the menu open would strand the page lock.
    window.addEventListener('resize', function () { if (!menu.hidden && window.innerWidth >= 990) menuSet(false); });
  }

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && !menu.hidden) menuSet(false);
    megaSet(false); searchSet(false);
  });

  /* ---------- Shop the Look: tap a photo's button to see the shirt in it ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t.closest && t.closest('.rx-look-btn');
    var closeBtn = t.closest && t.closest('[data-rx-look-close]');
    var inside = t.closest && t.closest('.rx-look');
    qsa('.rx-look.is-open').forEach(function (l) {
      if (l !== inside || closeBtn) {
        l.classList.remove('is-open');
        var b = qs('.rx-look-btn', l); if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
    if (btn && inside) {
      inside.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  /* ---------- collection page: sort menu and "Read more" on long descriptions ---------- */
  qsa('[data-rx-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });
  qsa('[data-rx-more]').forEach(function (btn) {
    var box = btn.previousElementSibling;
    if (!box) return;
    // Hide the button when the text already fits in three lines.
    if (box.scrollHeight <= box.clientHeight + 4) { btn.hidden = true; return; }
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  });

  /* ---------- product page: show the welcome discount to shoppers who arrived with the code ----------
     Shopify stores the code from a /discount/CODE link in the discount_code cookie and applies it in the
     bag. Until now the product page still showed full price, so an ad that promised 15% off landed on
     a page with no sign of it. The math is in rs-bag-logic.js (it matches Shopify to the cent). */
  function cookie(name) {
    var m = doc.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function cents(text) { var n = String(text).replace(/[^0-9.]/g, ''); return n ? Math.round(parseFloat(n) * 100) : 0; }
  qsa('[data-rx-welcome]').forEach(function (tag) {
    var code = (tag.getAttribute('data-code') || '').toLowerCase();
    var pct = Number(tag.getAttribute('data-percent')) || 0;
    if (!code || !pct || cookie('discount_code').toLowerCase() !== code) return;
    var targets = [tag.getAttribute('data-price'), tag.getAttribute('data-sticky')].map(function (sel) { return sel && qs(sel); }).filter(Boolean);
    function paint(el) {
      var L = window.RSBagLogic;
      if (!L || el.querySelector('s')) return; // already showing the discounted price
      var full = cents(el.textContent);
      if (!full) return;
      el.innerHTML = '<s>' + L.money(full) + '</s>' + L.money(L.discounted(full, pct));
    }
    function start() {
      if (!window.RSBagLogic) return;
      targets.forEach(function (el) {
        paint(el);
        // Eric's variant picker rewrites the price text; repaint when it does.
        new MutationObserver(function () { paint(el); }).observe(el, { childList: true, characterData: true, subtree: true });
      });
      tag.textContent = tag.getAttribute('data-label') || (pct + '% off');
      tag.hidden = false;
    }
    if (doc.readyState === 'complete') start(); else window.addEventListener('load', start);
  });

  /* ---------- bag icon opens the drawer when it exists ---------- */
  qsa('[data-rx-bag]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!window.RSCart || !window.RSCart.open) return; // fall back to the bag page
      if (/\/cart\/?$/.test(window.location.pathname)) return;
      e.preventDefault();
      window.RSCart.open();
    });
  });

  /* ---------- one-variant ADD buttons (data-rs-add="<variant id>") ---------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rs-add]');
    if (!btn || btn.disabled || btn.hasAttribute('data-rx-handled')) return;
    if (btn.closest('.rs-home')) return; // the old homepage section handles its own
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-rs-add')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        doc.dispatchEvent(new CustomEvent('rs:cart:updated'));
        doc.dispatchEvent(new CustomEvent('rs:cart:open'));
      })
      .catch(function () { btn.textContent = 'Try again'; })
      .then(function () { setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400); });
  });

  // Venture's theme.js expects theme.Notify from its own header code, which no longer runs.
  window.theme = window.theme || {};
  if (!window.theme.Notify) window.theme.Notify = { open: function () {}, close: function () {}, adaptNotification: function () {} };
})();

/* ---------- currency picker (Daniel, 2026-10-06; markup in snippets/rs-currency.liquid) ---------- */
(function () {
  var sels = document.querySelectorAll('[data-rx-cur]');
  if (!sels.length) return;
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  Array.prototype.forEach.call(sels, function (sel) {
    var here = sel.getAttribute('data-here'), best = {};
    function score(o) {
      var cur = o.getAttribute('data-cur'), iso = o.value;
      if (iso === here) return 4;
      if (cur === 'USD' && iso === 'US') return 3;
      if (cur.slice(0, 2) === iso) return 2;
      if (cur === 'EUR' && iso === 'DE') return 2;
      return 1;
    }
    Array.prototype.slice.call(sel.options).forEach(function (o) {
      var cur = o.getAttribute('data-cur'), s = score(o);
      if (!best[cur] || s > best[cur].s) best[cur] = { o: o, s: s };
    });
    var keep = Object.keys(best).sort(function (a, b) { return a === 'USD' ? -1 : b === 'USD' ? 1 : a < b ? -1 : 1; })
      .map(function (k) { return best[k].o; });
    var current = sel.getAttribute('data-current');
    sel.innerHTML = '';
    keep.forEach(function (o) { o.selected = o.getAttribute('data-cur') === current; sel.appendChild(o); });
    sel.style.visibility = '';
    sel.addEventListener('change', function () { store('rx_cur_chosen', '1'); sel.form.submit(); });
  });
  // Default to US dollars: a first-time shopper the store placed in another currency is switched once.
  var s = sels[0], cur = s.getAttribute('data-current');
  var guard = (function () { try { return sessionStorage.getItem('rx_cur_auto'); } catch (e) { return '1'; } })();
  if (cur && cur !== 'USD' && !guard) {   // always US dollars (US-only store); no picker to override it
    var us = s.querySelector('option[data-cur="USD"]');
    if (us) { try { sessionStorage.setItem('rx_cur_auto', '1'); } catch (e) {} s.value = us.value; s.form.submit(); }
  }
})();

// Lightbox for the homepage video feature (2026-10-26): opens a <dialog>, plays the full clip, and pauses it on close
// (X button, Esc, or a tap outside the video). The small inline clip only starts loading near the viewport.
(function () {
  var opens = document.querySelectorAll('[data-rx-lightbox-open]');
  if (!opens.length) return;
  Array.prototype.forEach.call(opens, function (btn) {
    var box = document.getElementById(btn.getAttribute('data-rx-lightbox-open'));
    if (!box || typeof box.showModal !== 'function') return;
    var vid = box.querySelector('video');
    btn.addEventListener('click', function () {
      box.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (vid) { try { vid.currentTime = 0; } catch (e) {} var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    });
    if (box.getAttribute('data-rx-wired')) return;
    box.setAttribute('data-rx-wired', '1');
    box.addEventListener('close', function () { if (vid) vid.pause(); document.documentElement.style.overflow = ''; });
    box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
    Array.prototype.forEach.call(box.querySelectorAll('[data-rx-lightbox-close]'), function (x) {
      x.addEventListener('click', function () { box.close(); });
    });
  });
  var lazy = document.querySelectorAll('video[data-rx-lazy-video]');
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      var v = en.target; io.unobserve(v); v.preload = 'auto';
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }, { rootMargin: '300px' });
  Array.prototype.forEach.call(lazy, function (v) { v.removeAttribute('autoplay'); io.observe(v); });
})();
